import Immutable from 'immutable';

const AuthenticationType: {
  [key: string]: string
} = {
  USER_PASSWORD: 'usr-pw',
  OKTA_LINK: 'okta',
  AZURE : 'azure'
};

const Content: {
  type: string,
  name: string,
  link: string | null
} = {
  type: AuthenticationType.USER_PASSWORD,
  name: 'AAServer',
  link: null
};

class AuthenticationMethod extends Immutable.Record(Content) {
  static get Type () {
    return AuthenticationType;
  }
}

export default AuthenticationMethod;
